/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ConversationalAgentGenerationInputs } from './ConversationalAgentGenerationInputs';
import {
  ConversationalAgentGenerationInputsFromJSON,
  ConversationalAgentGenerationInputsFromJSONTyped,
  ConversationalAgentGenerationInputsToJSON,
} from './ConversationalAgentGenerationInputs';

/**
 *
 * @export
 * @interface PaginatedConversationalAgentGenerationInputsList
 */
export interface PaginatedConversationalAgentGenerationInputsList {
  /**
   *
   * @type {number}
   * @memberof PaginatedConversationalAgentGenerationInputsList
   */
  count: number;
  /**
   *
   * @type {string}
   * @memberof PaginatedConversationalAgentGenerationInputsList
   */
  next?: string | null;
  /**
   *
   * @type {string}
   * @memberof PaginatedConversationalAgentGenerationInputsList
   */
  previous?: string | null;
  /**
   *
   * @type {Array<ConversationalAgentGenerationInputs>}
   * @memberof PaginatedConversationalAgentGenerationInputsList
   */
  results: Array<ConversationalAgentGenerationInputs>;
}

/**
 * Check if a given object implements the PaginatedConversationalAgentGenerationInputsList interface.
 */
export function instanceOfPaginatedConversationalAgentGenerationInputsList(
  value: object,
): value is PaginatedConversationalAgentGenerationInputsList {
  if (!('count' in value) || value['count'] === undefined) return false;
  if (!('results' in value) || value['results'] === undefined) return false;
  return true;
}

export function PaginatedConversationalAgentGenerationInputsListFromJSON(
  json: any,
): PaginatedConversationalAgentGenerationInputsList {
  return PaginatedConversationalAgentGenerationInputsListFromJSONTyped(json, false);
}

export function PaginatedConversationalAgentGenerationInputsListFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PaginatedConversationalAgentGenerationInputsList {
  if (json == null) {
    return json;
  }
  return {
    count: json['count'],
    next: json['next'] == null ? undefined : json['next'],
    previous: json['previous'] == null ? undefined : json['previous'],
    results: (json['results'] as Array<any>).map(ConversationalAgentGenerationInputsFromJSON),
  };
}

export function PaginatedConversationalAgentGenerationInputsListToJSON(
  value?: PaginatedConversationalAgentGenerationInputsList | null,
): any {
  if (value == null) {
    return value;
  }
  return {
    count: value['count'],
    next: value['next'],
    previous: value['previous'],
    results: (value['results'] as Array<any>).map(ConversationalAgentGenerationInputsToJSON),
  };
}
